import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { SecondaryHeader, Footer } from "../components/Frumy";
import { ShieldCheck, CheckCircle } from "@phosphor-icons/react";

export default function Privacy() {
  const { t } = useI18n();
  const nav = useNavigate();
  const points = t("privacyPoints");

  return (
    <div className="min-h-screen flex flex-col">
      <SecondaryHeader />

      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-12 w-full" data-testid="privacy-page">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="grid place-items-center h-12 w-12 rounded-xl bg-emerald-50 text-[var(--frumy-green)]">
            <ShieldCheck weight="fill" size={26} aria-hidden />
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-5">{t("privacyPageTitle")}</h1>
          <p className="text-base leading-relaxed text-[var(--text-muted)] mt-4 max-w-xl">{t("privacyIntro")}</p>

          <div className="mt-10 space-y-4">
            {points.map((pt, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.08 * i }}
                data-testid={`privacy-point-${i}`} className="frumy-card p-5 flex items-start gap-4">
                <span className="grid place-items-center h-8 w-8 rounded-full bg-emerald-100 text-[var(--frumy-green)] shrink-0">
                  <CheckCircle weight="fill" size={18} aria-hidden />
                </span>
                <div>
                  <h2 className="font-bold text-lg text-[var(--heading)]">{pt.h}</h2>
                  <p className="text-sm leading-relaxed text-[var(--text-muted)] mt-1">{pt.p}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="mt-10 flex justify-center">
            <button data-testid="privacy-cta" onClick={() => nav("/")}
              className="pill-btn cta-metal inline-flex items-center gap-2 text-white font-bold px-7 py-3.5">
              {t("getStarted")}
            </button>
          </div>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
